import React, { useState, useEffect } from 'react';

const humanizeSlug = (slug) =>
    slug
        .split(/[_-]/)
        .map(part => part.length > 0 ? part[0].toUpperCase() + part.slice(1) : part)
        .join(' ');

const formatSize = (bytes) => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
};

const formatDate = (iso) => {
    const d = new Date(iso);
    return d.toLocaleString(undefined, {
        year: 'numeric', month: 'short', day: 'numeric',
        hour: '2-digit', minute: '2-digit'
    });
};

export const Reports = () => {
    const [reports, setReports] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        let cancelled = false;
        fetch('api/reports')
            .then(r => r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`)))
            .then(data => { if (!cancelled) setReports(data); })
            .catch(err => { if (!cancelled) setError(err.message); });
        return () => { cancelled = true; };
    }, []);

    return (
        <div className="container py-4">
            <div className="d-flex align-items-baseline mb-3">
                <h2 className="mb-0">Reports</h2>
                <span className="text-muted ms-3 small">
                    {reports ? `${reports.length} available` : ''}
                </span>
            </div>
            <p className="text-muted">
                Standalone analysis reports. Each opens as its own page; share the URL directly.
            </p>

            {error && (
                <div className="alert alert-danger" role="alert">
                    Failed to load report list: {error}
                </div>
            )}

            {!reports && !error && (
                <p><em>Loading…</em></p>
            )}

            {reports && reports.length === 0 && (
                <p className="text-muted"><em>No reports published yet.</em></p>
            )}

            {reports && reports.length > 0 && (
                <div className="row g-3">
                    {reports.map(r => (
                        <div className="col-12 col-md-6 col-lg-4" key={r.slug}>
                            <a href={`/reports/${r.slug}`} className="text-decoration-none text-reset">
                                <div className="card card-clickable h-100 shadow-sm">
                                    <div className="card-body">
                                        <h5 className="card-title mb-1">{humanizeSlug(r.slug)}</h5>
                                        <div className="small mb-2" style={{ opacity: 0.75, fontFamily: 'monospace' }}>
                                            {r.slug}
                                        </div>
                                        <div className="d-flex justify-content-between small" style={{ opacity: 0.85 }}>
                                            <span>{formatDate(r.lastModified)}</span>
                                            <span>{formatSize(r.sizeBytes)}</span>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
